import { createContext, useState, useContext, useEffect, useCallback } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [rol, setRol] = useState(localStorage.getItem("rol") || "");
  const [jugadorId, setJugadorId] = useState(localStorage.getItem("jugadorId") || ""); // Nuevo estado

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("jugadorId"); // Eliminar jugadorId
    setToken("");
    setRol("");
    setJugadorId(""); // Limpiar estado
  }, []);

  useEffect(() => {
    let timeout;

    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        logout();
        window.location.href = "/login"; // Redirigir al login
      }, 5 * 60 * 1000); // 5 minutos
    };

    const events = ["click", "mousemove", "keydown", "scroll"];

    events.forEach((event) => window.addEventListener(event, resetTimeout));

    resetTimeout(); // Inicializar el temporizador

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => window.removeEventListener(event, resetTimeout));
    };
  }, [logout]);

  const login = (token, userRol, idJugador) => {
    localStorage.setItem("token", token);
    localStorage.setItem("rol", userRol);
    localStorage.setItem("jugadorId", idJugador); // Guardar jugadorId
    setToken(token);
    setRol(userRol);
    setJugadorId(idJugador); // Actualizar estado
  };

  return (
    <AuthContext.Provider value={{ token, rol, jugadorId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);